import React from 'react';
import {
  AsyncBoundary,
  AsyncBoundaryInjectorParams,
} from 'utils/asyncBoundary/asyncBoundaryTypes';

export const createAsyncBoundary = (): AsyncBoundary => ({
  injectPromise() {
    // MOCK
  },
  active: false,
});

export const createAsyncBoundaryInjectorParams = (): AsyncBoundaryInjectorParams => ({
  shouldShowFallback: true,
});

export const AsyncBoundaryContext = React.createContext<AsyncBoundary>(
  createAsyncBoundary()
);
